import React, { useContext } from 'react';
import { LogoLoading } from 'ensightful-koala-ui';

import { CreateFromScratch, EditTeams } from 'components/organisms/Teams';
import { useUser2 } from 'contexts/user2';
import { useViewport } from 'contexts/viewport';
import withResponsiveLayout from 'hoc/withResponsive';
import { PageContext } from 'pages/Teams/PageProvider';
import Mobile from 'pages/Teams/mobile';
import Tablet from 'pages/Teams/tablet';
import Desktop from 'pages/Teams/desktop';
import { AlertDialog } from 'shell/components';
import SyncRosterDialog from 'components/organisms/Teams/SyncRosterDialog';
import GroupSyncDialog from 'components/organisms/Teams/GroupSyncDialog';

const PageLayout = () => {
    const { isLoading } = useUser2();
    const { width } = useViewport();

    const props = useContext(PageContext);

    const responsiveLayouts = {
        mobile: <Mobile {...props} />,
        tablet: <Tablet {...props} />,
        desktop: <Desktop {...props} />,
    };

    return isLoading ? (
        <LogoLoading />
    ) : (
        <>
            {withResponsiveLayout(width, responsiveLayouts)}
            <CreateFromScratch />
            <EditTeams />
            <SyncRosterDialog
                loading={props.isSyncRosterLoading}
                open={props.syncRosterDialog.open}
                isGroupSyncing={props.syncRosterDialog.isGroupSyncing}
                setSyncGroupDialog={props.setSyncGroupDialog}
                onClose={() => props.setSyncRosterDialog({ open: false })}
            />
            <GroupSyncDialog
                open={props.syncGroupDialog.open}
                sendGroupSetUpdate={props.sendGroupSetUpdate}
                onClose={() => props.setSyncGroupDialog({ open: false })}
            />
            <AlertDialog
                message={props.dialog.message}
                description={props.dialog.description}
                open={props.dialog.open}
                variant={props.dialog.variant}
                actionButtonText={props.dialog.actionButtonText}
                onAction={props.dialog.onAction}
                onCancel={() => props.setDialog((current) => ({ ...current, open: false }))}
                onClose={() => props.setDialog((current) => ({ ...current, open: false }))}
            />
        </>
    );
};

export default PageLayout;
